import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './admin/admin-layout.component';
import { AuthGuard } from './auth/auth.guard';

export const AppRoutes: Routes = [
    {
      path: '',
      redirectTo: 'associado-list',
      pathMatch: 'full',
    }, {
      path: '',
      component: AdminLayoutComponent,
      children: [
        {
            path: '',
            loadChildren: './views/views.module#ViewsModule'
        }
      ],
      canActivate: [AuthGuard]
      
    },
];
